export const CREATE_PERMISSION = 'create';
